import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import {
  EManualFindingStatus,
  ICreateManualFindingStatusPayload,
  IGetManualFindingStatusParams,
  IManualFindingStatus,
} from '@interfaces/manual-finding-status.interface';
import { snakeCase } from 'lodash';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ManualFindingStatusService {
  private readonly http = inject(HttpClient);

  public getAll(params: IGetManualFindingStatusParams): Observable<IApiResponse<IManualFindingStatus[]>> {
    return this.http.get<IApiResponse<IManualFindingStatus[]>>('/manual-finding-status', {
      params: this.buildGetAllParams(params),
    });
  }

  public getAllExport(
    exportId: string,
    params: IGetManualFindingStatusParams,
  ): Observable<IApiResponse<IManualFindingStatus[]>> {
    return this.http.get<IApiResponse<IManualFindingStatus[]>>(`/manual-finding-status/export/${exportId}`, {
      params: this.buildGetAllParams(params),
    });
  }

  private buildGetAllParams(params: IGetManualFindingStatusParams): HttpParams {
    let httpParams = new HttpParams();

    if (params.campaignId) httpParams = httpParams.set('campaign_id', params.campaignId);

    if (params.creatorId) httpParams = httpParams.set('creator_id', params.creatorId);

    if (params.deliverableId) httpParams = httpParams.set('deliverable_id', params.deliverableId);

    if (params.parentId) httpParams = httpParams.set('parent_id', params.parentId);

    if (params.socialContentId) httpParams = httpParams.set('social_content_id', params.socialContentId);

    if (params.findingType !== undefined) httpParams = httpParams.set('finding_type', snakeCase(params.findingType));

    if (params.findingId) httpParams = httpParams.set('finding_id', params.findingId);

    if (params.processed !== undefined) httpParams = httpParams.set('processed', String(params.processed));

    return httpParams;
  }

  public create(payload: ICreateManualFindingStatusPayload): Observable<IApiResponse<IManualFindingStatus>> {
    return this.http.post<IApiResponse<IManualFindingStatus>>('/manual-finding-status', {
      ...payload,
      findingType: snakeCase(payload.findingType),
      status: EManualFindingStatus.removed,
    });
  }

  public update(
    id: string,
    payload: ICreateManualFindingStatusPayload & { status: EManualFindingStatus | null },
  ): Observable<IApiResponse<IManualFindingStatus>> {
    return this.http.put<IApiResponse<IManualFindingStatus>>(`/manual-finding-status/${id}`, {
      ...payload,
      findingType: snakeCase(payload.findingType),
    });
  }
}
